import axios from 'axios';

/**
 * Klient HTTP strony klienckiej.
 *
 * Strona jest wizytówką aplikacji i nie loguje nikogo, więc odpytuje wyłącznie
 * publiczne końcówki: dokumenty prawne oraz potwierdzenie adresu e-mail i reset
 * hasła (oba z jednorazowym tokenem z linku w wiadomości). Nie ma tu tokenów w
 * localStorage, nagłówka Authorization ani odświeżania sesji, bo nie ma sesji.
 */
const API_URL = process.env.REACT_APP_API_URL;

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'X-App': 'client-web',
  },
});

export default api;
